import React, { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import {
  quizAnswerHistoryState,
  quizAnswersState,
  quizHistoryStepState,
} from '../../../utils/recoil/quiz';
import { Button } from '../../UI/Elements';
import { QuizForm } from '../../UI/Forms/Quiz/quiz';

import { createPortal } from 'react-dom';
import clsx from 'clsx';
import QuizStart from 'components/Marketing/Quiz/QuizStart';
import QuizResult from 'components/Marketing/Quiz/QuizResult';
import { formatContentfulComponentProps } from 'utils/globals';

const Modal = ({ children, onClose }) => {
  React.useEffect(() => {
    document.body.className = clsx(document.body.className, 'overflow-hidden');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return () => {
      document.body.className = clsx(
        document.body.className.replace('overflow-hidden', '')
      );
    };
  }, []);
  return (
    <div
      className={clsx(
        'fixed',
        'z-60',
        'top-0 bottom-0',
        'left-0 right-0',
        'w-full',
        'h-full',
        'bg-gray-200',
        'overflow-auto',
        'no-scrollbar'
      )}>
      {children}

      <div className={'fixed top-8 right-8'}>
        <Button
          onClick={onClose}
          type='contained'
          size='base'
          color={{ classname: 'black' }}
          icon={{
            iconKey: 'HiOutlineX',
            size: 'xl',
          }}
        />
      </div>
    </div>
  );
};
function ReactPortal(children, wrapperId, onClose) {
  return createPortal(
    <Modal onClose={onClose}>{children}</Modal>,
    document.getElementById(wrapperId)
  );
}

enum QUIZ_STATUS {
  START,
  RUNNING,
  END,
}

export const Quiz = ({ form, startPage, resultPage }) => {
  // TODO CHECK if QUIZ result exist in local storage, if yes display cached results

  const resetQuizAnswerState = useResetRecoilState(quizAnswersState);
  const resetQuizHistoryStep = useResetRecoilState(quizHistoryStepState);
  const resetQuizAnswerHistoryState = useResetRecoilState(
    quizAnswerHistoryState
  );
  const [status, setStatus] = useState(QUIZ_STATUS.START);

  const quizAnswerState = useRecoilValue(quizAnswersState);

  const resetQuiz = () => {
    resetQuizAnswerState();
    resetQuizHistoryStep();
    resetQuizAnswerHistoryState();
    setStatus(QUIZ_STATUS.START);
  };

  if (status === QUIZ_STATUS.START) {
    return (
      <QuizStart
        startQuiz={() => {
          setStatus(QUIZ_STATUS.RUNNING);
        }}
        {...formatContentfulComponentProps(startPage)}
      />
    );
  } else if (status === QUIZ_STATUS.RUNNING) {
    return ReactPortal(
      <QuizForm
        {...formatContentfulComponentProps(startPage)}
        form={form}
        reset={resetQuiz}
        finish={() => setStatus(QUIZ_STATUS.END)}
      />,
      'modal-root',
      () => {
        if (Object.keys(quizAnswerState).length > 2) {
          setStatus(QUIZ_STATUS.END);
        } else {
          resetQuiz();
        }
      }
    );
  } else if (status === QUIZ_STATUS.END) {
    return (
      <QuizResult
        resetQuiz={resetQuiz}
        {...formatContentfulComponentProps(resultPage)}
      />
    );
  }

  return null;
};
